/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import {
  OPTIONS_SEXE_ETCV_AVEC_INDETERMINE,
  TYPE_COMPONENT_BY_TYPE_ACTE,
} from '@/constants';

import { estReconnaissancePrenatale } from '@/utils';

import InformationsEnfant from '../StepActe/InformationsEnfant';

/** Date et heure de naissance, grisées avant la naissance (AD-12845). */
const CHAMPS_NAISSANCE = [
  'jourNaissance',
  'moisNaissance',
  'anneeNaissance',
  'heureNaissance',
  'minuteNaissance',
];

/**
 * Étape « Enfant » de l'acte de reconnaissance : `INFORMATIONS SUR L'ENFANT`
 * extraite de l'étape « Acte » (`StepActeReconnaissance`) dans sa propre
 * étape, affichée avant celle des parents.
 */
const StepEnfant = () => {
  const { data, onChange, errors, selectedTypeActe } =
    React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Enfant] ?? {};

  const prenatale = estReconnaissancePrenatale(data?.codeSousTypeActe);

  /*
   * Champs grisés : une valeur saisie avant de passer au sous-type « Avant la
   * naissance » ne doit ni rester affichée ni peser sur la validation.
   */
  // biome-ignore lint/correctness/useExhaustiveDependencies: seul le passage au sous-type prénatal déclenche le nettoyage
  React.useEffect(() => {
    if (!prenatale) {
      return;
    }
    _.forEach(CHAMPS_NAISSANCE, (name) => {
      if (!_.isNil(data?.[name])) {
        onChange(null, { name, value: null });
      }
    });
  }, [prenatale]);

  const typeComponent = selectedTypeActe
    ? TYPE_COMPONENT_BY_TYPE_ACTE[selectedTypeActe]
    : undefined;

  return (
    <div
      className="assistant-step-enfant"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsEnfant
        data={data}
        errors={errorsStep}
        onChange={onChange}
        showLieuNaissance={false}
        typeComponent={typeComponent}
        optionsSexe={OPTIONS_SEXE_ETCV_AVEC_INDETERMINE}
        disabledNaissance={prenatale}
      />
    </div>
  );
};

export default StepEnfant;
